import { Environment, generateEmptyApi } from '@environment';

const customFrontendModules = {
  'work-with-us': () => import('../custom-modules/work-with-us.component').then(m => m.WorkWithUsComponent),
  'work-with-us-page': () =>
    import('../custom-modules/work-with-us-page.component').then(m => m.WorkWithUsPageComponent)
};

export const environment: Environment = {
  api: generateEmptyApi(),
  appType: 'cdp',
  siteName: 'cinemalive Releasing',
  appHasOnlyMovies: false,
  copyrightMsg: '',
  customPageParams: {
    headerSMsearchCollapse: true,
    headerSMsearchActive: true,
    channelVideoAutoplay: true,
    channelVideoEmbed: true
  },
  tracking: {
    sessionExpiredMinutes: 120
  },
  showtimeStreamingConfig: {
    performanceHourAttributes: true
  },

  movieSiteGlobalConfig: {
    topMenu: {
      // backgroundLargeScreen: 'var(--background-color)'
      backgroundLargeScreen: 'black'
    },
    footer: {
      logoContrast: 'none'
    }
  },
  movieSiteConfig: {
    'westlife-in-cinemas': {
      topMenu: {
        backgroundLargeScreen: 'var(--brand-color)'
      },
      footer: {
        logoContrast: 'none'
      }
    },
    grow: {}
  },
  components: {
    cookieConsent: {
      policyUrl: '/cookie-policy',
      providerName: 'usheru',
      policyVersion: '2026-09-24'
    },
    channelVideo: {
      hideBackgroundImageOnVideo: true,
      disableVolumeControl: true
    },
    header: {
      dynamicHostAttrsEnabled: true,
      positionOverContentLg: false,
      positionOverContentSm: false,
      positionFixed: true,
      pageOverrideRules: [
        {
          paths: ['/', '/home', '/work-with-us'],
          config: {
            positionOverContentLg: true
          }
        },
        {
          regex: '^/movie/[^/]+$',
          config: {
            positionOverContentLg: true
          }
        }
      ]
    }
  },
  placeholderData: {
    // movie: 'clifford-the-big-red-dog',
    // performancesGroup: true,
    // nearestCities: true,
    // streamingLinks: true
  },
  logosConfig: {
    footer: {
      logoUrl: 'https://cdnstatic.usheru.com/img/channels/cinemalive.usheru.com/footer-image.png'
    }
  },
  customFrontendModules: customFrontendModules
};
